import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

export default function CancelPage() {
  const navigate = useNavigate();

  useEffect(() => {
    toast.error('Platba byla zrušena. Žádné peníze nebyly odečteny.');
    // Přesměrování na stránku s kredity po 3 sekundách
    const timeout = setTimeout(() => {
      navigate('/buy-credits');
    }, 3000);

    return () => clearTimeout(timeout);
  }, [navigate]);

  return (
    <div className="max-w-2xl mx-auto p-6 text-center">
      <h1 className="text-3xl font-bold mb-4">Platba byla zrušena</h1>
      <p className="text-gray-600 mb-6">
        Vaše platba byla zrušena. Žádné peníze nebyly odečteny.
      </p>
      <p className="text-sm text-gray-500">
        Budete přesměrováni zpět na stránku s kredity...
      </p>
    </div>
  );
} 